import React from 'react';

export const getDateRange = (date) => {
    if (!date) return { dateFrom: '', dateTo: '' };
    const [startDateStr, endDateStr] = date.split('-');
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    // Set the start time to the beginning of the day
    startDate.setHours(0, 0, 0, 0);

    // Set the end time to the end of the day
    endDate.setHours(23, 59, 59, 999);
    return {
        dateFrom: startDate.getTime(),
        dateTo: endDate.getTime(),
    };
};

export default getDateRange;
